import { render, staticRenderFns } from "./AisQueryTile.vue?vue&type=template&id=2ddb7b5e&scoped=true"
import script from "./AisQueryTile.vue?vue&type=script&lang=ts"
export * from "./AisQueryTile.vue?vue&type=script&lang=ts"
import style0 from "./AisQueryTile.vue?vue&type=style&index=0&id=2ddb7b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddb7b5e",
  null
  
)

export default component.exports